import { appImages } from "../../../cdnImages.js"
import React from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

import Header from "../common/Header.jsx"
import "../../../css/Common.css"

import styles from "./index.module.css"

const LandingLayout = props => {
    const { isLoggedIn } = useSelector(store => store.auth)
    return isLoggedIn ? (
        <Navigate to="/" replace />
    ) : (
        <div className={styles.rootContainer}>
            <div className={styles.landing_container}>
                <div className={`${styles.info} ${styles.left}`}>
                    <Header />
                    <div className={styles.main_text}>
                        <h1>{`Welcome to ${process.env?.REACT_APP_COMPANY}`}</h1>
                        <p className="mt-12">
                            {`A comprehensive dashboard to monitor and control all your ${process.env?.REACT_APP_COMPANY} EV solutions. Monitor
                            transactions and charging in real-time and stay updated with all aspects of operations.`}
                        </p>
                    </div>
                    <img className={styles.login_graphic} src={appImages?.login__graphic} alt="box" />
                </div>
                <div className={`${styles.info} ${styles.right}`}>
                    {props.children}
                    <div className={styles.footer_msg}>© Sharify services private limited All rights reserved</div>
                </div>
            </div>
        </div>
    )
}

export default LandingLayout
